/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */

import React from 'react';

const NavigationDots = ({ active }) => (
  <div className="flex flex-col items-center justify-center p-4 ">
    {['', 'about', 'work', 'skills', 'testimonial', 'contact'].map((item, index) => (
      <a
        href={`#${item}`}
        key={item + index}
        className="h-2 m-2 w-2 rounded-full bg-gray-600 xl:h-3 xl:w-3 lg:h-3 lg:w-3 hover:bg-blue-600 "
        style={active === item ? { backgroundColor: '#313BAC' } : {}}
      />
    ))}
  </div>
);

export default NavigationDots;